import { render, staticRenderFns } from "./ChatGpt.vue?vue&type=template&id=3cd2b02e&scoped=true"
import script from "./ChatGpt.vue?vue&type=script&lang=js"
export * from "./ChatGpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd2b02e",
  null
  
)

export default component.exports